const items = [
  {
    href: '/pld/catalogs/actions',
    title: 'actions',
  },
  {
    href: '/pld/catalogs/monetary_instruments',
    title: 'Instrumentos monetarios',
  },
  {
    href: '/pld/catalogs/country_jurisdiction',
    title: 'country_jurisdiction',
  },
  {
    href: '/pld/catalogs/operation_master',
    title: 'Maestro de operaciones',
  },
  {
    href: '/pld/catalogs/parameters',
    title: 'Parámetros generales',
  },
  {
    href: '/pld/catalogs/reporting_reasons',
    title: 'Razones de reporte',
  },
  {
    href: '/pld/catalogs/alert_types',
    title: 'Tipos de alertas',
  },
  {
    href: '/pld/catalogs/operation_types',
    title: 'Tipo de operación',
  },
];

export default items;
